exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rootlayout[data-v-3dd2e005] {\n   position: absolute;\n   top: 0px;\n   bottom: 0px;\n   left: 0px;\n   width: 100%;\n}\n.el-main[data-v-3dd2e005] {\n  padding: 20px;\n  background-color: #f2f2f2;\n}\n.el-header[data-v-3dd2e005] {\n   -webkit-box-shadow: 0px 0px 25px #333;\n           box-shadow: 0px 0px 25px #333;\n   background-color: #f2f2f2;\n}\n", ""]);

// exports
